import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import CenterState, {CenterList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<CenterState> = {
  [mutationType.GET_LISTS](
    state: CenterState,
    data: CenterList,
  ): void {
    state.list = data
  },
}

export default mutations
